// Branded ID types — single source of truth for entity identifiers across the
// platform. Every Drizzle table primary key has a matching brand here; the
// `ids-coverage` CI lint asserts the set is exhaustive.
export const asUserId = (s) => s;
export const asSessionId = (s) => s;
export const asGroupId = (s) => s;
export const asEventId = (s) => s;
export const asInviteId = (s) => s;
export const asMembershipRequestId = (s) => s;
export const asResourceId = (s) => s;
export const asPostId = (s) => s;
export const asCommentId = (s) => s;
export const asMessageId = (s) => s;
export const asThreadId = (s) => s;
export const asConversationId = (s) => s;
export const asDsrRequestId = (s) => s;
export const TOMBSTONE_USER_ID = '00000000-0000-0000-0000-000000000000';
//# sourceMappingURL=ids.js.map